import { Name, UInt64 } from '@greymass/eosio'

export const NAME_ENCODED_KEYS: ReadonlySet<string> = new Set([
  'fee.account',
  'manager',
  'mine.account',
  'orac.account',
])

export function isNameEncodedKey(key: string): boolean {
  return NAME_ENCODED_KEYS.has(key)
}

export function uint64ToName(value: string | number): string {
  return Name.from(UInt64.from(String(value))).toString()
}

export function nameToUint64(name: string): string {
  return Name.from(name).value.toString()
}
